function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,128.000000) scale(0.100000,-0.100000)",
  fill: "#000000",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M525 1165 c-134 -29 -246 -104 -325 -216 -61 -88 -90 -174 -97 -289 -6 -110 -17 -136 -64 -161 -38 -19 -39 -21 -39 -75 l0 -56 458 232 c251 128 539 275 640 327 l182 95 0 55 0 54 -202 -104 c-112 -57 -356 -182 -542 -277 l-339 -173 5 87 c11 167 102 301 256 374 73 35 82 37 177 37 80 0 113 -5 166 -24 l65 -23 42 21 c23 12 42 25 42 30 0 15 -129 72 -197 86 -83 18 -149 18 -228 0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M637 581 l-637 -325 0 -54 c0 -29 4 -52 8 -50 5 2 245 123 534 271 289 147 529 267 533 267 4 0 6 -37 3 -83 -3 -66 -11 -96 -36 -150 -101 -216 -361 -319 -571 -226 l-46 20 -47 -22 c-27 -12 -48 -26 -48 -29 0 -15 119 -70 181 -85 275 -64 551 87 642 354 11 32 23 101 27 160 6 99 8 105 37 130 16 14 37 31 47 36 14 8 17 21 14 61 l-3 51 -638 -326z"
}));

function SvgXlm(_ref, svgRef) {
  let title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "128.000000pt",
    height: "128.000000pt",
    viewBox: "0 0 128.000000 128.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlm);
export default __webpack_public_path__ + "static/media/xlm.8bcde7f38872bbfba47ba09262f638ab.svg";
export { ForwardRef as ReactComponent };